export function cleanHtml(html: string) {
	return html.replace(/<\/?[^>]+(>|$)/g, "");
}